/* unplugin-vue-components disabled */import { render } from "./Loaging.vue?vue&type=template&id=2c4dfdb5&scoped=true"
import script from "./Loaging.vue?vue&type=script&lang=js"
export * from "./Loaging.vue?vue&type=script&lang=js"

import "./Loaging.vue?vue&type=style&index=0&id=2c4dfdb5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4dfdb5"]])

export default __exports__